export default {
  user: {
    savedUser: null,
    savedPlay: null
  },
  api: { ok: false, loading: false, error: false }
};
